@if (updates.visible()) {
  <section
    class="border-b border-bb-border bg-bb-bg-secondary text-bb-text-primary"
    aria-label="Application update"
  >
    <div
      class="flex min-h-12 w-full flex-wrap items-center gap-x-3 gap-y-2 px-4 py-2 lg:px-6"
    >
      <ui-icon
        name="refresh"
        size="md"
        class="shrink-0 text-bb-accent-blue"
        aria-hidden="true"
      />

      <div class="min-w-0 grow" role="status" aria-live="polite" aria-atomic="true">
        @switch (updates.status()) {
          @case ("ready") {
            <p class="text-sm font-semibold">Application update ready</p>
            <p class="text-xs text-bb-text-secondary">
              Reload when it is safe to apply the latest release.
            </p>
          }
          @case ("installation-failed") {
            <p class="text-sm font-semibold">
              Application update needs attention
            </p>
            <p class="text-xs text-bb-text-secondary">
              The new release could not be cached. Reload to retry the
              application update.
            </p>
          }
          @case ("unrecoverable") {
            <p class="text-sm font-semibold text-bb-accent-red">
              Reload required
            </p>
            <p class="text-xs text-bb-text-secondary">
              This cached application version can no longer load every required
              file.
            </p>
          }
        }
      </div>

      <button
        type="button"
        class="inline-flex h-8 shrink-0 items-center justify-center gap-2 rounded border border-bb-accent-blue bg-bb-accent-blue px-3 text-xs font-semibold text-white transition-colors hover:bg-bb-accent-blue/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-bb-accent-blue focus-visible:ring-offset-2 focus-visible:ring-offset-bb-bg-secondary disabled:cursor-wait disabled:opacity-60"
        [disabled]="updates.reloading()"
        (click)="reload()"
      >
        <ui-icon
          name="refresh"
          size="sm"
          [spin]="updates.reloading()"
          aria-hidden="true"
        />
        <span>{{ updates.reloading() ? "Reloading..." : "Reload now" }}</span>
      </button>
    </div>
  </section>
}
